import React from "react";
import tekk from "../../assets/logo/tekk_ai.png";
import ASCLogo from "../../assets/logo/header_logo.png";
import "./style.css";

const Footer = () => {
  // Deliberate product decision: the relocated header_logo.png here is
  // permanent and unconditional — it always shows, regardless of whether a
  // tenant Display Name/Company Name is set. Matches the same choice made
  // for assyst-client-portal's Footer.tsx. Header's own top-left slot still
  // swaps to the Display Name only once one is set (see Header/index.tsx).
  return (
    <footer>
      <div className="footer-logo">
        <img src={ASCLogo} alt="assyst_logo" height="24px" />
      </div>
      <div className="footer-copy">
        <p>&copy;{new Date().getFullYear()}&nbsp;
           Assyst Software and Consultancy Ltd., a fully owned subsidiary of</p>&nbsp;
        <img src={tekk} alt="tekk.ai" height="30px" />&nbsp;
        <p>an ISO 9001 and ISO 27001 certified company</p>
      </div>
    </footer>
  );
};

export default Footer;
